import TextField from '@mui/material/TextField';
import { useTranslate } from 'react-admin';
import { Controller } from 'react-hook-form';

import React from 'react';
import { NumericFormat } from 'react-number-format';

const NumberFormatCustom = React.forwardRef(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={0}
        fixedDecimalScale={false}
      />
    );
  }
);
export const InputTextFormatter = ({
  name,
  control,
  label,
  type = 'text',
  variant = 'filled',
  className = '',
  register,
  validation = {},
  required = false,
}) => {
  const translate = useTranslate();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          required={required}
          type={type}
          helperText={error ? translate(error?.message) : null}
          size="small"
          error={!!error}
          onChange={onChange}
          value={value}
          fullWidth
          label={label}
          variant={variant}
          className={className}
          InputProps={{
            inputComponent: NumberFormatCustom,
          }}
          {...register(name, validation)}
        />
      )}
    />
  );
};
